import { FC } from 'react';
import type { ReactElement } from 'react';
import DefaultLayout from './DefaultLayout';

const HiddenTopBarAndFooter: FC<{ children: ReactElement }> = ({
  children,
}) => (
  <DefaultLayout hideTopBar hideFooter>
    {children}
  </DefaultLayout>
);

export default HiddenTopBarAndFooter;
